import React, { useEffect } from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import HomePage from "../pages/home";
import AboutPage from "../pages/about";
import LoginPage from "../pages/login";
import useAuthGlobal from "../context/useAuthGlobal";
import useUserMe from "../hooks/me/useUserMe";
import ProductPage from "src/components/product/page";
import MainLayout from "src/components/shared/MainLayout";
import UserPage from "src/components/user/page";
import UserProfilePage from "src/components/user-profile/page";
import WarehousePage from "src/components/warehouse/page";
import WarehouseManagementPage from "src/components/warehouse-management/page";
import BatchPage from "src/components/warehouse-management/batch/page";
import InventoryOutTable from "src/pages/warehouse-management/inventory-out";
import InventoryInTable from "src/pages/warehouse-management/inventory-in";
import SettingPage from "src/components/setting/page";
import TransportationProviderPage from "src/components/setting/transportation-provider/page";
import OrdersPage from "src/components/orders/page";
import FinancePage from "src/components/finance/page";
import InventoryPage from "src/components/warehouse-management/inventory/page";
import ProviderPage from "src/components/setting/providers/page";
import ErrorBoundary from "src/components/shared/ErrorBoundary";
import OrderDetailPage from "src/components/orders/[slug]/page";
import CreateOrderPage from "src/pages/orders/create/page";
import DebtPage from "src/pages/debt";
import BankInfoPage from "src/pages/bank-info";

const MainRoutes = () => {
  const { setUserMe, setMeLoading } = useAuthGlobal();
  const { data: userMe, isLoading } = useUserMe();
  useEffect(() => {
    setMeLoading(isLoading);
    if (isLoading) return;

    const token = localStorage.getItem("token");
    if (token && userMe?.data) {
      setUserMe(userMe.data);
    } else if (!token) {
      setUserMe(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userMe, isLoading, setUserMe]);
  const router = createBrowserRouter([
    {
      path: "/",
      element: <LoginPage />,
    },
    {
      path: "/home",
      element: (
        <MainLayout>
          <HomePage />
        </MainLayout>
      ),
    },
    {
      path: "/about",
      element: (
        <MainLayout>
          <AboutPage />
        </MainLayout>
      ),
    },
    {
      path: "/product",
      element: (
        <MainLayout>
          <ProductPage />
        </MainLayout>
      ),
    },
    {
      path: "/debt",
      element: (
        <MainLayout>
          <DebtPage />
        </MainLayout>
      ),
    },
    {
      path: "/order/create",
      element: (
        <MainLayout>
          <CreateOrderPage />
        </MainLayout>
      ),
    },
    {
      path: "/user",
      element: (
        <MainLayout>
          <UserPage />
        </MainLayout>
      ),
    },
    {
      path: "/user-profile",
      element: (
        <MainLayout>
          <UserProfilePage />
        </MainLayout>
      ),
    },

    {
      path: "/warehouse-management",
      element: (
        <MainLayout>
          <WarehouseManagementPage />
        </MainLayout>
      ),
    },
    {
      path: "/warehouse-management/inventory",
      element: (
        <MainLayout>
          <InventoryPage />
        </MainLayout>
      ),
    },
    {
      path: "/warehouse-management/inventory-in",
      element: (
        <MainLayout>
          <InventoryInTable />
        </MainLayout>
      ),
    },
    {
      path: "/warehouse-management?tab=inventory-out",
      element: (
        <MainLayout>
          <InventoryOutTable />
        </MainLayout>
      ),
    },
    {
      path: "/warehouse-management/batch",
      element: (
        <MainLayout>
          <BatchPage />
        </MainLayout>
      ),
    },
    {
      path: "/setting",
      element: (
        <MainLayout>
          <SettingPage />
        </MainLayout>
      ),
    },
    {
      path: "/setting/providers",
      element: (
        <MainLayout>
          <ProviderPage />
        </MainLayout>
      ),
    },
    {
      path: "/setting/warehouse",
      element: (
        <MainLayout>
          <WarehousePage />
        </MainLayout>
      ),
    },
    {
      path: "/setting/transportation-provider",
      element: (
        <MainLayout>
          <TransportationProviderPage />
        </MainLayout>
      ),
    },
    {
      path: "/orders",
      element: (
        <MainLayout>
          <OrdersPage />
        </MainLayout>
      ),
    },
    {
      path: "/orders/:id",
      element: (
        <MainLayout>
          <OrderDetailPage />
        </MainLayout>
      ),
    },
    {
      path: "/finance",
      element: (
        <MainLayout>
          <FinancePage />
        </MainLayout>
      ),
    },
    {
      path: "/bank-info",
      element: (
        <MainLayout>
          <BankInfoPage />
        </MainLayout>
      ),
    },
  ]);
  return (
    <ErrorBoundary>
      <RouterProvider router={router} />
    </ErrorBoundary>
  );
};

export default MainRoutes;
